export default "__VITE_ASSET__Cmrrvhi8__"